var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 43,
    viewBox: "0 0 90 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.658813 32.2072C8.70401 52.0245 86.0096 41.7996 89.2809 23.4054C94.4362 -5.58271 24.0987 -2.94744 14.0734 6.53958C13.7021 6.89094 13.7629 7.54 14.0734 7.40043C41.2416 -4.8097 90.7258 2.90291 86.5337 23.4054C81.6995 39.0238 2.49619 50.1974 2.17509 28.6935C1.96367 14.5348 37.4241 1.19874 63.076 5.45032C63.8431 5.27463 63.2392 4.5064 62.3981 4.34349C34.891 -0.193885 -5.41264 13.2998 0.658813 32.2072Z",
    fill: "#FF533F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircle);
export default __webpack_public_path__ + "static/media/circle.621b6a698c76944c5ec6908f12895e34.svg";
export { ForwardRef as ReactComponent };